import PropTypes from 'prop-types';
import React from 'react';

const StatusBudget = ({ status, text }) => {
  const s = status ? status : 'info';
  return <div className={'budget bg-' + s}>{text}</div>;
};

StatusBudget.propTypes = {
  status: PropTypes.string,
  text: PropTypes.any,
};

export default StatusBudget;
